/**
 * @generated SignedSource<<71bd89e5eb46257ba4616989ff624258>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useFeedTypeSelectorWriteFragment$data = {
  readonly feedTab: string | null | undefined;
  readonly " $fragmentType": "useFeedTypeSelectorWriteFragment";
};
export type useFeedTypeSelectorWriteFragment$key = {
  readonly " $data"?: useFeedTypeSelectorWriteFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFeedTypeSelectorWriteFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useFeedTypeSelectorWriteFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "feedTab"
    }
  ],
  "type": "UserPreferences"
};

(node as any).hash = "4d2d2b2e6fd75a844316ed9aca89be96";

export default node;
